import React, { Component } from "react";
import { connect } from "react-redux";
import Immutable from "immutable";
import FontAwesome from "react-fontawesome";

import Modal from '@mawesi-sas/mws_react_component_modal';
import Input from '@mawesi-sas/mws_react_component_input';
import ButtonStrip from "../../Layout/components/ButtonStrip";
import BoxButton from "../../Layout/components/BoxButton";

import {
  showHideModalEditStatus,
  modificarEstadoSolicitudesSeleccionadas
} from "../actions";

class ModalEditStatus extends Component {
  modalContent = () => {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label className="control-label">Nuevo estado</label>
              <Input
                type="select"
                reducer="solicitudes"
                path="modalEditStatus.data.estado"
                options={[
                  { caption: "FACTURADA", value: "FACTURADA" },
                  { caption: "PROCESADA", value: "PROCESADA" },
                  {
                    caption: "COMPLETADA",
                    value: "COMPLETADA"
                  },
                  { caption: "APROBADA", value: "APROBADA" },
                  { caption: "CREADA", value: "CREADA" }
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { modalEditStatus } = this.props;

    return (
      <Modal
        ancho="400px"
        mostrar={modalEditStatus.get("show")}
        contenido={this.modalContent()}
        titulo={`Modificación de estado de solicitudes seleccionadas`}
        nombre="modal_editar_estado_solicitud"
        onCerrarModal={() => this.props.showHideModalEditStatus(false)}
        botones={
          <React.Fragment>
            <button
              className="btn btn-sm btn-primary"
              onClick={e =>
                this.props.modificarEstadoSolicitudesSeleccionadas()
              }
            >
              Cambiar
            </button>
          </React.Fragment>
        }
      />
    );
  }
}

const mapStateToProps = (state, onwProps) => {
  return {
    modalEditStatus: state.solicitudes.get("modalEditStatus")
  };
};

const mapDispatchToProps = {
  showHideModalEditStatus,
  modificarEstadoSolicitudesSeleccionadas
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditStatus);
